import SharedTransferenciaSection from '../_shared/TransferenciaSection';

// Mantenha em sincronia com lais-ai/src/agents/ecommerce/identity.js →
// DEFAULT_AGENT_CONFIG.transferencia. `value` é o identificador persistido e
// comparado pelo runtime; `i18nKey` fica separado porque os values são
// snake_case e a convenção das chaves de i18n é camelCase.
const GATILHOS_PREDEFINIDOS = [
    {
        value: 'quer_comprar',
        i18nKey: 'querComprar',
        title: 'Cliente quer comprar',
        description: 'Quando o cliente demonstra intenção clara de fechar ("vou levar", "como faço pra pagar?").',
        icon: 'mdi:cart-check',
    },
    {
        value: 'carrinho_montado',
        i18nKey: 'carrinhoMontado',
        title: 'Carrinho montado',
        description: 'Quando o cliente já definiu produtos e quantidades e falta só fechar o pedido.',
        icon: 'mdi:cart-outline',
    },
    {
        value: 'quer_atendente',
        i18nKey: 'querAtendente',
        title: 'Cliente pediu atendente humano',
        description: 'Quando o cliente diz "quero falar com alguém", "tem um vendedor?", etc.',
        icon: 'mdi:account-tie-outline',
    },
    {
        value: 'sem_estoque',
        i18nKey: 'semEstoque',
        title: 'Produto sem estoque',
        description: 'Quando o item que o cliente quer está esgotado ou fora de linha e não há substituto adequado.',
        icon: 'mdi:package-variant-remove',
    },
    {
        value: 'pedido_atacado',
        i18nKey: 'pedidoAtacado',
        title: 'Pedido em quantidade / atacado',
        description: 'Quando o volume pedido foge do varejo e precisa de condição comercial negociada.',
        icon: 'mdi:warehouse',
    },
    {
        value: 'reclamacao_troca',
        i18nKey: 'reclamacaoTroca',
        title: 'Reclamação, troca ou devolução',
        description: 'Quando o cliente relata problema com um produto recebido ou quer trocar/devolver.',
        icon: 'mdi:alert-octagon-outline',
    },
    {
        value: 'pos_venda',
        i18nKey: 'posVenda',
        title: 'Dúvida sobre pedido já feito',
        description: 'Quando o cliente pergunta status, rastreio ou prazo de um pedido existente.',
        icon: 'mdi:truck-delivery-outline',
    },
];

export default function TransferenciaSection({ aiAgent, changeModuleConfig }) {
    return (
        <SharedTransferenciaSection
            aiAgent={aiAgent}
            changeModuleConfig={changeModuleConfig}
            moduleKey="ecommerce"
            gatilhos={GATILHOS_PREDEFINIDOS}
            i18nBase="aiAgents.ecommerce.transferencia."
        />
    );
}
